import { render, staticRenderFns } from "./MobileCoaConfirmationSuccess.vue?vue&type=template&id=bf31d7ea&scoped=true"
import script from "./MobileCoaConfirmationSuccess.vue?vue&type=script&lang=js"
export * from "./MobileCoaConfirmationSuccess.vue?vue&type=script&lang=js"
import style0 from "./MobileCoaConfirmationSuccess.vue?vue&type=style&index=0&id=bf31d7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf31d7ea",
  null
  
)

export default component.exports